var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoverLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    zoomAndPan: "magnify",
    viewBox: "0 0 224.87999 225",
    height: 300,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "71123efffb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.714844 4.773438 L 220.164062 4.773438 L 220.164062 220.226562 L 4.714844 220.226562 Z M 4.714844 4.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f0a3aff207"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 112.441406 4.773438 C 52.945312 4.773438 4.714844 53.003906 4.714844 112.5 C 4.714844 171.996094 52.945312 220.226562 112.441406 220.226562 C 171.933594 220.226562 220.164062 171.996094 220.164062 112.5 C 220.164062 53.003906 171.933594 4.773438 112.441406 4.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "34594ca5e6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 29.4375 53.257812 L 195.097656 53.257812 L 195.097656 171.695312 L 29.4375 171.695312 Z M 29.4375 53.257812 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#71123efffb)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f0a3aff207)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5e21d0",
    d: "M 4.714844 4.773438 L 220.164062 4.773438 L 220.164062 220.226562 L 4.714844 220.226562 Z M 4.714844 4.773438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#34594ca5e6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 47.234375 53.257812 C 37.441406 53.257812 29.5 61.199219 29.5 71.023438 C 29.71875 97.960938 29.5 126.476562 29.5 153.929688 C 29.5 163.382812 36.84375 171.035156 46.128906 171.601562 L 178.039062 171.695312 C 187.496094 171.3125 195.039062 163.507812 195.039062 153.929688 L 195.039062 67.96875 C 193.601562 59.59375 186.34375 53.257812 177.578125 53.257812 C 134.15625 53.277344 90.675781 53.257812 47.234375 53.257812 Z M 46.960938 62.601562 L 178.132812 62.601562 L 114.667969 126.171875 C 113.511719 127.332031 111.671875 127.332031 110.511719 126.171875 L 46.957031 62.601562 Z M 186.171875 67.136719 L 186.171875 153.28125 C 186.171875 158.414062 184.324219 161.3125 180.628906 162.347656 L 135.917969 117.472656 Z M 39.386719 67.507812 L 88.808594 117.011719 L 43.636719 162.257812 C 40.542969 161.210938 39.46875 158.714844 39.386719 155.316406 Z M 95.089844 123.207031 L 110.515625 138.753906 C 111.675781 139.910156 113.515625 139.910156 114.671875 138.753906 L 129.636719 123.761719 L 168.621094 162.8125 L 55.554688 162.8125 Z M 95.089844 123.207031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverLetter);
export default __webpack_public_path__ + "static/media/cover-letter.d635a29a5d106bb0abf18d3c1a7a460e.svg";
export { ForwardRef as ReactComponent };